// 홈 히어로 슬라이드쇼에 상품이 최대 몇 개까지 들어갈지 정하는 상수.
// 페이지 쿼리(page.tsx가 Product.showInHero로 몇 개까지 가져올지)와
// 슬라이드쇼 컴포넌트(HeroSlideshow.tsx가 안전망으로 다시 자르는 개수)가
// 같은 값을 써야 어긋나지 않으므로 한 곳에서만 정의한다.
//
// 예전엔 진열순서 상위 3개가 무조건 나갔지만, 이제는 사장님이 직접 상품을
// 고른다. 상품 몇 개짜리 소규모 농장 쇼핑몰에서는 5개 정도를 다 보여줘도
// 무리가 없지만, 그 이상을 자동전환(6초 간격)으로 계속 돌리면 처음 들어온
// 손님이 한 바퀴 다 보기까지 너무 오래 걸려 히어로 영역이 "계속 뭔가 바뀌는
// 중"으로만 보이고 만다. 그래서 5개로 상한을 둔다.
export const MAX_HERO_PRODUCT_SLIDES = 5;

// 홈 히어로 슬라이드쇼에 배너가 최대 몇 개까지 들어갈지 정하는 상수.
// 위 상품 상한과 같은 이유(SLIDE_INTERVAL_MILLISECONDS=6초 간격 자동전환
// 기준으로 5개면 이미 한 바퀴에 30초)로 동일하게 5개를 상한으로 둔다.
// 배너가 하나라도 있으면 상품 슬라이드는 아예 나오지 않으므로
// (HeroSlideshow.tsx 참고) 두 종류가 섞여 상한을 넘는 일은 없다.
export const MAX_HERO_BANNER_SLIDES = 5;
